import { TArticleContentSummary } from '../../../shared/newsArticleShared';

// Action Types
export const SET_ARTICLE_CONTENT = 'SET_ARTICLE_CONTENT';
export const SET_ARTICLE_LOADING = 'SET_ARTICLE_LOADING';
export const SET_ARTICLE_WEEKLY_ROUTES = 'SET_ARTICLE_WEEKLY_ROUTES';
export const SET_ARTICLE_WEEKLY_ROUTES_LOADING = 'SET_ARTICLE_WEEKLY_ROUTES_LOADING';
export const SET_ARTICLES_PLAY_LIKE_THE_PROS = 'SET_ARTICLES_PLAY_LIKE_THE_PROS';
export const SET_ARTICLES_PLAY_LIKE_THE_PROS_LOADING = 'SET_ARTICLES_PLAY_LIKE_THE_PROS_LOADING';

// Action Creator
const NewsArticleActionCreator = {
  setArticleContent(articleId: string, details: any) {
    if (typeof rioDebouncedRefreshWowheadTooltips === 'function') {
      rioDebouncedRefreshWowheadTooltips();
    }

    return {
      type: SET_ARTICLE_CONTENT,
      payload: {
        articleId,
        ...details
      }
    };
  },
  setArticleLoading(loading: boolean) {
    return {
      type: SET_ARTICLE_LOADING,
      payload: {
        loading
      }
    };
  },
  setArticlesWeeklyRoute(articles: TArticleContentSummary[]) {
    return {
      type: SET_ARTICLE_WEEKLY_ROUTES,
      payload: {
        articles,
      }
    };
  },
  setArticlesWeeklyRouteLoading(loading: boolean) {
    return {
      type: SET_ARTICLE_WEEKLY_ROUTES_LOADING,
      payload: {
        loading
      }
    };
  },
  setArticlesPlayLikeThePros(articles: TArticleContentSummary[]) {
    return {
      type: SET_ARTICLES_PLAY_LIKE_THE_PROS,
      payload: {
        articles,
      }
    };
  },
  setArticlesPlayLikeTheProsLoading(loading: boolean) {
    return {
      type: SET_ARTICLES_PLAY_LIKE_THE_PROS_LOADING,
      payload: {
        loading
      }
    };
  }
};

export default NewsArticleActionCreator;
